import React from 'react';
import Stack from '@mui/material/Stack';
import { Button, Box, Slide, Dialog, Chip } from '@mui/material';

import EventIcon        from '@mui/icons-material/Event';
import WbSunnyIcon      from '@mui/icons-material/WbSunny';
import ThermostatIcon   from '@mui/icons-material/Thermostat';
import AcUnitIcon       from '@mui/icons-material/AcUnit';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SchoolIcon       from '@mui/icons-material/School';
import GpsFixedIcon     from '@mui/icons-material/GpsFixed';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import SearchIcon from '@mui/icons-material/Search';

import Qx from './qx.js';
import HeatStressForecastAdvanced from './HeatStressForecastAdvanced.js';
import CatCheck from './CatCheck.js';
import MakatSearch from './MakatSearch.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const btn = {
    justifyContent: 'flex-start',
    borderRadius: 2,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.95rem',
};

function Header() {
    const [qxOpen, setQxOpen]             = React.useState(false);
    const [forecastOpen, setForecastOpen] = React.useState(false);
    const [catOpen, setCatOpen]           = React.useState(false);
    const [makatOpen, setMakatOpen]       = React.useState(false);

    return (
        <Box
            sx={{
                backgroundImage: "url('https://i.imgur.com/XOCqJH9.jpeg')",
                backgroundRepeat: 'no-repeat',
                minHeight: { xs: 'auto', sm: '585px' },
                width: '100%',
                backgroundSize: { xs: 'cover', sm: 'contain' },
                backgroundAttachment: 'scroll',
                backgroundPosition: 'center top',
                py: { xs: 3, sm: 0 },
            }}
        >
            <Stack
                sx={{ width: { xs: '85%', sm: '60%' }, margin: '0 auto', height: { sm: '585px' } }}
                direction="column"
                justifyContent="center"
                spacing={1.5}
            >
                <Box sx={{ position: 'relative' }}>
                    <Button fullWidth variant="contained" startIcon={<SearchIcon />} onClick={() => setMakatOpen(true)} sx={btn}>חיפוש מק"ט</Button>
                    <Chip label="חדש" size="small" sx={{
                        position: 'absolute', top: -8, left: -8,
                        bgcolor: '#ff9800', color: '#fff',
                        fontWeight: 700, fontSize: '0.7rem',
                        height: 20, borderRadius: '10px', pointerEvents: 'none',
                    }} />
                </Box>

                <Button href="#gimel" variant="contained" startIcon={<EventIcon />} sx={btn}>מחשבון גימלים</Button>

                <Box sx={{ position: 'relative' }}>
                    <Button fullWidth variant="contained" startIcon={<MedicalServicesIcon />} onClick={() => setCatOpen(true)} sx={btn}>בדיקת תוקף CAT</Button>
                    <Chip
                        label="חדש"
                        size="small"
                        sx={{
                            position: 'absolute',
                            top: -8,
                            left: -8,
                            bgcolor: '#ff9800',
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: '0.7rem',
                            height: 20,
                            borderRadius: '10px',
                            pointerEvents: 'none',
                        }}
                    />
                </Box>

                <HeatStressForecastAdvanced open={forecastOpen} onClose={() => setForecastOpen(false)} />
                <Button variant="contained" startIcon={<WbSunnyIcon />} onClick={() => setForecastOpen(true)} sx={btn}>תחזית עומס חום</Button>

                <Button href="#hot" variant="contained" startIcon={<ThermostatIcon />} sx={btn}>מחשבון עומס חום</Button>

                <Button href="#cold" variant="contained" startIcon={<AcUnitIcon />} sx={btn}>מחשבון עומס קור</Button>

                <Button href="#ana" variant="contained" startIcon={<PersonSearchIcon />} sx={btn}>אנמנזה</Button>

                <Button href="https://training.idfmedic.com/" variant="contained" startIcon={<SchoolIcon />} sx={btn}>אפליקציית תרגול</Button>

                <Button variant="contained" startIcon={<GpsFixedIcon />} onClick={() => setQxOpen(true)} sx={btn}>QXGO</Button>

                <Dialog fullScreen open={qxOpen} onClose={() => setQxOpen(false)} TransitionComponent={Transition}>
                    <Qx handleClose={() => setQxOpen(false)} />
                </Dialog>

                <CatCheck open={catOpen} handleClose={() => setCatOpen(false)} />
                <MakatSearch open={makatOpen} handleClose={() => setMakatOpen(false)} />
            </Stack>
        </Box>
    );
}

export default Header;
